/** 交易订单相关常量 */

// 交易订单类型
export const ORDER_TYPE = {
  LMT: 'LMT', // 限价单（只能改为市价单）
  MKT: 'MKT', // 市价单
  STP: 'STP', // 止损单（只能改为市价单）
  STP_LMT: 'STP_LMT', // 止损限价单（只能改为限价单）
  TRAIL: 'TRAIL', // 跟踪单
  TRAIL_1: 'TRAIL_1', // 跟踪百分百
  TRAIL_2: 'TRAIL_2', // 跟踪额
  MAIN: 'MAIN', //  主订单
  BRACKETS: 'BRACKETS', // 括号订单（即附加单同时下单止盈止损）
  PROFIT: 'PROFIT', // 止盈单（即附加订单限价单）
  LOSS: 'LOSS' // 止损（即市价单）
}

// 订单有效时间
export const TIME_IN_FORCE = {
  DAY: 'DAY', // 当日有效
  GTC: 'GTC', // 取消前有效
  GTD: 'GTD', // 指定日期前有效
  AUC: 'AUC' // 集合竞价
}

// 订单状态
export const ORDER_STATUS = {
  NO_RESULT: -1, // 订单已提交到交易所，但交易所还没有返回结果
  PRE_SUBMIT: 2, // PRE_SUBING待成交
  PENDING_CANCEL: 3, // 待取消
  CANCELLED: 4, // 已取消
  SUBMITTED: 5, // 已提交（或部分成交）
  FILLED: 6, // 成交
  REJECTED: 7, // 已拒绝
  PENDING_SUBMIT: 8 // 待提交
}

// 标准账户订单状态
export const OMNIBUS_ORDER_STATUS = {
  NEW: 'New', // 新订单
  PENDING_NEW: 'PendingNew', // 待提交
  CANCELED: 'Canceled', // 已取消
  REJECTED: 'Rejected', // 已拒绝
  EXPIRED: 'Expired', // 已过期
  FILLED: 'Filled' // 已成交
}

// 货币类型
export const CURRENCY_TYPE = {
  US: 'USD', // 美股
  HK: 'HKD', // 港股
  CN: 'CNH', // 沪港通
  UK: 'GBP', // 英镑
  EU: 'EUR' // 欧元
}

// 货币符号
export const CURRENCY_SYMBOL = {
  USD: '$',
  HKD: 'HK$',
  GBP: '￡',
  CNH: '¥',
  EUR: '€'
}

// 止盈止损比率
export const PROFIT_LOSS_RATE = {
  MAIN: 0.08, // 主订单
  ATTACH_PROFIT: 0.1, // 附加单止盈
  ATTACH_LOSS: 0.07 // 附加单止损
}

// 美股交易所代码
export const US_EXCHANGE_SHORT_CODE_MAP = {
  a: 'AMEX',
  b: 'BX',
  c: 'NSX',
  d: 'ADF',
  h: 'MIAX',
  i: 'ISE',
  j: 'EDGA',
  k: 'EDGX',
  l: 'LTSE',
  m: 'CHO',
  n: 'NYSE',
  p: 'ARCA',
  s: 'CTS',
  t: 'NSDQ',
  u: 'MEMX',
  v: 'IEX',
  w: 'CBSX',
  x: 'PSX',
  y: 'BYX',
  z: 'BZX',
  bo: 'BOATS'
}
